export const InstallerScheduleAsync = () => import("./InstallerSchedule.vue");
